import { useState, useEffect } from "react";
import { useQueryClient } from "react-query";
import { MassUploadFullView } from "./MassUploadFullView";
import Modal from "../../../../components/Modal";
import Table from "../../../../components/tables/Table";
import {
  validateCarrierMassUpload,
  validateCarrierContactMassUpload,
  massUploadCarrier,
  downloadCarrierTemplate,
} from "../../../../actions/CarrierAgreementMgmt/Carrier";
import ConfirmBoxDelete from "../../../../components/ConfirmBoxDelete";
import EditButton from "../../../../components/EditButton";
import HideButton from "../../../../components/HideButton";
import SaveDataButton from "../../../../components/SaveDataButton";
import ShowButton from "../../../../components/ShowButton";
import { toast } from "../../../../components/toastNotification";
import { useRecoilState } from "recoil";
import {
  carrierContactMassUploadState,
  carrierMassUploadState,
} from "../atom/atoms";
import * as XLSXFiles from "xlsx";
import UploadFileButton from "../../../../components/UploadFileButton";
import TemplateButton from "../../../../components/TemplateButton";
const MassUpload = ({ isOpen, isForMassUploadCarrier, refetchGetCarriers }) => {
  const [, setCarrierMassUploadModal] = useRecoilState(carrierMassUploadState);
  const [, setContactMassUploadModal] = useRecoilState(
    carrierContactMassUploadState
  );
  const [xlsx, setXlsx] = useState<any>(null);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [validData, setValidData] = useState([]);
  const [invalidData, setInvalidData] = useState([]);
  const [allData, setAllData] = useState([]);
  const [origData, setOrigData] = useState([]);
  const [selectedTab, setSelectedTab] = useState("All");
  const [openModal, setOpenModal] = useState(false);

  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleClear, setToggleCleared] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [show, setShow] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [DisplayNote, setDisplayNote] = useState(false);
  const queryClient = useQueryClient();

  const hasValidData =
    origData && origData?.filter((data: any) => data.isValid).length > 0;

  const XLSX_LOAD_DELAY_MS = 2000;

  useEffect(() => {
    const scriptShim = document.createElement("script");
    scriptShim.async = true;
    scriptShim.src =
      "https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.17.3/shim.min.js";
    scriptShim.integrity =
      "824a6ade25af712b2dabb1dc9d30f3441b5b1652fd7fa43a9f6ba99607849a6334c1baf0085047e4d2692a06e4ed299af067d71ffdf7986225cc041c6d8d71b8"; //C0nF!esH1m //sha512
    scriptShim.crossOrigin = "anonymous";

    const scriptXLS = document.createElement("script");
    scriptXLS.async = true;
    scriptXLS.src =
      "https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.17.3/xlsx.full.min.js";
    scriptXLS.integrity =
      "ce7e2434109f7c48061d1a110f5d2082e827dd41a0d9bb3950be8e3adea03f7508aa287b5c177754cf32dab771212d7de2f03d8a19d685b0dfc8a8452fd8172f"; //C0nF!eXLs //sha512
    scriptXLS.crossOrigin = "anonymous";

    scriptXLS.onload = () => {
      setXlsx(XLSXFiles);
    };

    document.body.appendChild(scriptShim);
    document.body.appendChild(scriptXLS);

    const timer = globalThis.setTimeout(
      () => setLoading(false),
      XLSX_LOAD_DELAY_MS
    );

    return () => {
      clearTimeout(timer);
      scriptShim?.remove();
      scriptXLS?.remove();
    };
  }, []);

  const user = localStorage.getItem("userName");

  const UploadFile = (e) => {
    if (e.target.files.length > 0) {
      setLoading(true);
      const reader = new FileReader();
      const excelFile = e.target.files[0];
      reader.onload = (e) => {
        const result = e?.target?.result;

        try {
          const readedData = xlsx?.read(result, {
            type: "binary",
            sheetRows: 1,
          });

          const wsname = readedData?.SheetNames[0];
          const ws = readedData?.Sheets[wsname];
          /* Convert array to json*/
          const dataParse = xlsx?.utils.sheet_to_json(ws, { header: 1 });
          if (
            (dataParse[0].includes("Carrier Name required") &&
              dataParse[0].includes("State required") &&
              isForMassUploadCarrier) ||
            (dataParse[0].includes("Carrier Name required") &&
              dataParse[0].includes(
                "Contact Destination: National / NSA / SPLC /Specific State (ex. AL)"
              ) &&
              !isForMassUploadCarrier)
          ) {
            //To Identify if State column is in file. invalid if state is in file and mass upload is for contact information
            if (
              dataParse[0].includes("State required") &&
              !isForMassUploadCarrier
            ) {
              setDisplayNote(false);
              setLoading(false);
              toast.fire(
                isForMassUploadCarrier
                  ? "Uploading Carrier Failed"
                  : "Uploading Carrier Contact Failed",
                "Invalid file!",
                "error"
              );
            } else {
              setLoading(false);
              const wb = xlsx?.read(result, {
                type: "binary",
                cellDates: true,
                dateNF: "YYYY-MM-DD",
              });
              const xData = xlsx?.utils.sheet_to_json(
                wb.Sheets[wb.SheetNames[0]]
              );

              if (xData.length > 0) {
                setData(xData);
                setDisplayNote(true);
              } else {
                setDisplayNote(false);
                setLoading(false);
                toast.fire(
                  isForMassUploadCarrier
                    ? "Uploading Carrier Failed"
                    : "Uploading Carrier Contact Failed",
                  "Invalid file, required fields must have value",
                  "error"
                );
              }
            }
          } else {
            setDisplayNote(false);
            setLoading(false);
            if (
              (dataParse[0].includes("Specific State (ex. AL) required") &&
                !isForMassUploadCarrier) ||
              (!dataParse[0].includes("State required") &&
                isForMassUploadCarrier)
            ) {
              toast.fire(
                isForMassUploadCarrier
                  ? "Uploading Carrier Failed"
                  : "Uploading Carrier Contact Failed",
                "Invalid file!",
                "error"
              );
            } else {
              toast.fire(
                isForMassUploadCarrier
                  ? "Uploading Carrier Failed"
                  : "Uploading Carrier Contact Failed",
                "Invalid file, missing Carrier required fields",
                "error"
              );
            }
          }
        } catch (e) {
          setDisplayNote(false);
          toast.fire("Upload Failed", "Cannot read file.", "error");
          setLoading(false);
        }
      };
      reader.readAsBinaryString(excelFile);

      e.target.value = null;
    }
  };

  useEffect(() => {
    if (data?.length > 0) {
      setLoading(true);
      var xData = data.map((carrier) => {
        return {
          carrierName:
            carrier["Carrier Name required"] === undefined
              ? ""
              : String(carrier["Carrier Name required"]),
          alias: carrier["Alias"] === undefined ? "" : String(carrier["Alias"]),
          states:
            carrier["State required"] === undefined
              ? ""
              : carrier["State required"],
          address:
            carrier["Address"] === undefined ? "" : String(carrier["Address"]),
          fein: carrier["FEIN"] === undefined ? "" : String(carrier["FEIN"]),
          naic: carrier["NAIC"] === undefined ? "" : String(carrier["NAIC"]),
          contactType:
            carrier["Contact Type"] === undefined
              ? ""
              : String(carrier["Contact Type"]),
          name: carrier["Name"] === undefined ? "" : String(carrier["Name"]),
          email: carrier["Email"] === undefined ? "" : String(carrier["Email"]),
          carrierEAndOSubmissionType:
            carrier["E&O Submission Type(Email/Online)"] === undefined
              ? ""
              : String(carrier["E&O Submission Type(Email/Online)"]),
          url: carrier["URL"] === undefined ? "" : String(carrier["URL"]),
          phoneTypeName:
            carrier["Select Type (Home/Work/Fax)"] === undefined
              ? ""
              : String(carrier["Select Type (Home/Work/Fax)"]),
          phoneNumber:
            carrier["Phone Number"] === undefined
              ? ""
              : String(carrier["Phone Number"]),
          contactDestination:
            carrier[
              "Contact Destination: National / NSA / SPLC /Specific State (ex. AL)"
            ] === undefined
              ? ""
              : String(
                  carrier[
                    "Contact Destination: National / NSA / SPLC /Specific State (ex. AL)"
                  ]
                )?.trim(),
        };
      });
      isForMassUploadCarrier
        ? validateCarrierMassUpload(xData)
            .then((res) => {
              const updatedData = res?.map((data, index) => {
                return { ...data, id: index, expandRow: false };
              });

              setAllData(updatedData);
              setOrigData(updatedData);

              setLoading(false);
              setSelectedTab("All");
            })
            .catch((err) => {
              setAllData([]);
              setOrigData([]);
              setLoading(false);
              setDisplayNote(false);
              toast.fire("Upload Failed", "Invalid data in file", "error");
            })
        : validateCarrierContactMassUpload(xData)
            .then((res) => {
              const updatedData = res?.map((data, index) => {
                return { ...data, id: index, expandRow: false };
              });

              setAllData(updatedData);
              setOrigData(updatedData);

              setLoading(false);
              setSelectedTab("All");
            })
            .catch((err) => {
              setAllData([]);
              setOrigData([]);
              setLoading(false);
              setDisplayNote(false);
              toast.fire("Upload Failed", "Invalid data in file", "error");
            });
    }
  }, [data]);

  const handleActions = (row, type) => {
    const updatedData: any = origData.map((d: any) =>
      d.id === row.id ? { ...d, expandRow: !d.expandRow } : d
    );

    if (type === "Show") {
      setShow(true);
      setDisplayNote(false);
      setAllData(updatedData);
    } else if (type === "Hide") {
      if (selectedTab === "Valid") {
        setAllData(validData);
      } else if (selectedTab === "Invalid") {
        setAllData(invalidData);
      } else {
        setAllData(origData);
      }

      setShow(false);
      setShowEdit(false);
      setDisplayNote(true);
    } else if (type === "Edit") {
      setAllData(updatedData);
      setShow(false);
      setShowEdit(true);
      setDisplayNote(false);
    }
  };

  const columns = [
    {
      name: "Findings",
      left: "true",
      cell: (row) => {
        return (
          <div className="text-xs3 items-left text-left">
            {row.isValid ? "Valid" : row.invalidDetails}{" "}
          </div>
        );
      },
    },
    {
      name: "Carrier",
      left: "true",
      selector: (row) => {
        return (
          <div className="text-xs3 items-left text-left">{row.carrierName}</div>
        );
      },
    },
    {
      name: "Alias",
      left: "true",
      selector: (row) => {
        return <div className="text-xs3 items-left text-left">{row.alias}</div>;
      },
    },
    {
      name: "State",
      left: "true",
      selector: (row) => {
        return (
          <div className="text-xs3 items-left text-left">{row.states}</div>
        );
      },
    },
    {
      name: "FEIN",
      left: "true",
      omit: isForMassUploadCarrier ? false : true,
      selector: (row) => {
        return <div className="text-xs3 items-left text-left">{row.fein}</div>;
      },
    },
    {
      name: "NAIC",
      left: "true",
      omit: isForMassUploadCarrier ? false : true,
      selector: (row) => {
        return <div className="text-xs3 items-left text-left">{row.naic}</div>;
      },
    },
    {
      name: "Address",
      left: "true",
      selector: (row) => {
        return (
          <div className="text-xs3 items-left text-left">{row.address}</div>
        );
      },
    },
    {
      name: "Actions",
      center: "true",
      cell: (row) => {
        return (
          <div className="flex 2xl:flex-row flex-col justify-center items-center">
            <div className="flex flex-row">
              {row.expandRow ? (
                <HideButton
                  buttonText="Hide"
                  onClick={() => {
                    handleActions(row, "Hide");
                  }}
                  className={undefined}
                />
              ) : (
                ""
              )}

              <div className="flex flex-col justify-center items-center opacity-100 gap-x-2 space-x-1 space-y-1">
                {row.expandRow ? (
                  ""
                ) : (
                  <ShowButton
                    className={
                      (show || showEdit || selectedRows.length > 0
                        ? "opacity-50"
                        : "opacity-100") + ""
                    }
                    disabled={
                      showEdit || show || selectedRows.length > 0 ? true : false
                    }
                    buttonText="Show"
                    onClick={() => {
                      handleActions(row, "Show");
                    }}
                  />
                )}

                {row.expandRow ? (
                  ""
                ) : (
                  <EditButton
                    className={
                      (show || showEdit || selectedRows.length > 0
                        ? "opacity-50"
                        : "opacity-100") + ""
                    }
                    disabled={show || showEdit || selectedRows.length > 0}
                    buttonText="Edit"
                    onClick={() => {
                      handleActions(row, "Edit");
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        );
      },
    },
  ];
  const tabs = ["All", "Valid", "Invalid"];

  const SaveMassUploadData = () => {
    setUploading(true);
    const carrier = origData.map((x: any) => {
      return { ...x, createdBy: user, modifiedBy: user };
    });
    massUploadCarrier(carrier)
      .then((res) => {
        queryClient.invalidateQueries("Carriers");
        setUploading(false);
        setAllData(res.data);
        setOrigData(res.data);

        if (res && res.data.length > 0) {
          queryClient.invalidateQueries("GetAllCarriers");
          refetchGetCarriers().then((result) => {
            if (result.isSuccess && result.data) {
              toast.fire(
                "Warning",
                "Not all data were saved. Please edit data with error(s)",
                "warning"
              );
            }
          });
        } else {
          setUploading(false);
          queryClient.invalidateQueries("GetAllCarriers");
          refetchGetCarriers().then((result) => {
            if (result.isSuccess && result.data) {
              toast.fire(
                "Success",
                "Your data has been saved successfully",
                "success"
              );
              closeModal();
            }
          });
        }
      })
      .catch((e) => {
        setUploading(false);

        toast.fire(
          "Save Failed",
          "We encountered an error when saving your data.",
          "error"
        );
      });
  };

  useEffect(() => {
    if (!isOpen) {
      setAllData([]);
      setInvalidData([]);
      setValidData([]);
    }
  }, [isOpen]);

  const downloadTemplate = () => {
    downloadCarrierTemplate(isForMassUploadCarrier).then((content) => {
      var url = window.URL.createObjectURL(content.data);
      let templateName = isForMassUploadCarrier
        ? "MassUploadCarrierTemplate.xlsx"
        : "MassUploadCarrierContactsTemplate.xlsx";
      let tempLink = document.createElement("a");

      tempLink.href = url;
      tempLink.setAttribute("download", templateName);
      tempLink.click();
    });
  };

  const handleSelectedTab = (tab, data) => {
    setSelectedTab(tab);

    if (tab === "All") {
      setAllData(origData);
    }
    if (tab === "Valid") {
      if (data !== null) {
        const valids = data.filter((data: any) => data.isValid);
        setValidData(valids);
        setAllData(valids);
      } else {
        const valids = origData.filter((data: any) => data.isValid);
        setValidData(valids);
        setAllData(valids);
      }
    }
    if (tab === "Invalid") {
      if (data !== null) {
        const invalids = data.filter((data: any) => !data.isValid);
        setInvalidData(invalids);
        setAllData(invalids);
      } else {
        const invalids = origData.filter((data: any) => !data.isValid);
        setInvalidData(invalids);
        setAllData(invalids);
      }
    }
  };

  const handleSelectedRowsChange = (state) => {
    setSelectedRows(state.selectedRows);
  };

  const handleDelete = () => {
    const ids = selectedRows.map((d: any) => d.id);
    const newData = origData.filter((d: any) => !ids.includes(d.id));
    setOrigData(newData);
    setAllData(newData);
    setOpenModal(false);
    setSelectedRows([]);
    setToggleCleared(!toggleClear);
    if (selectedTab === "Invalid" || selectedTab === "Valid") {
      handleSelectedTab(selectedTab, newData);
    }
    toast.fire("Success", "Carriers were deleted successfully.", "success");
  };

  const updateRow = (currentData) => {
    const updatedData = origData.map((data: any) => {
      if (currentData.id === data.id) {
        data = currentData;
      }
      return data;
    });

    isForMassUploadCarrier
      ? validateCarrierMassUpload(updatedData).then((res) => {
          const updatedData = res?.map((data, index) => {
            return { ...data, id: index, expandRow: false };
          });
          toast.fire(
            "Success",
            "Carrier Mass Upload Updated Successfully.",
            "success"
          );
          setAllData(updatedData);
          setOrigData(updatedData);

          setLoading(false);
          setSelectedTab("All");
        })
      : validateCarrierContactMassUpload(updatedData).then((res) => {
          const updatedData = res?.map((data, index) => {
            return { ...data, id: index, expandRow: false };
          });
          toast.fire(
            "Success",
            "Carrier Contact Mass Upload Updated Successfully",
            "success"
          );
          setAllData(updatedData);
          setOrigData(updatedData);

          setLoading(false);
          setSelectedTab("All");
        });

    setShow(false);
    setShowEdit(false);
  };

  const closeModal = () => {
    setShow(false);
    setShowEdit(false);
    setDisplayNote(true);
    setData([]);
    setSelectedRows([]);
    setOrigData([]);
    setSelectedTab("All");
    setCarrierMassUploadModal(false);
    setContactMassUploadModal(false);
  };
  const openDeleteModal = () => {
    setOpenModal(true);
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={() => closeModal()}
      closeOutside={false}
      title={undefined}
      className={undefined}
      modalFilterStat={undefined}
    >
      <ConfirmBoxDelete
        ModalTitle="Delete Carrier"
        qConfirmation={"Are you sure you want to delete Carrier(s)?"}
        isOpen={openModal}
        onClose={() => setOpenModal(false)}
        onClickFunction={() => {
          handleDelete();
          setDisplayNote(true);
        }}
        cancelButtonRef={undefined}
      />
      <div className="">
        <div className="font-bold text-xl flex items-center m-2">
          <div className="text-base text-primary font-bold">
            {isForMassUploadCarrier
              ? "Carrier Mass Upload"
              : "Carrier Contact Mass Upload"}
          </div>
          <div className="ml-auto flex items-center ">
            <TemplateButton
              onClick={downloadTemplate}
              btnClassName={
                selectedRows.length > 0 || show || showEdit
                  ? "opacity-50"
                  : "opacity-50"
              }
              disabled={
                selectedRows.length > 0 || show || showEdit ? true : false
              }
            />
            <UploadFileButton
              onChange={UploadFile}
              disabled={
                selectedRows.length > 0 || show || showEdit || loading
                  ? true
                  : false
              }
            />
          </div>
        </div>
        <div className="mt-2 h-1 w-full border-b-4 border-secondary" />
        <div>
          <div className="flex justify-between">
            <div>
              {tabs.map((tab, index) => {
                return (
                  <button
                    key={index}
                    onClick={() => handleSelectedTab(tab, null)}
                    className={`border-b-4 font-medium text-sm text-tertiary cursor-pointer transition py-3 px-5  
                     ${
                       selectedTab === tab
                         ? "border-primary font-bold bg-gray-50"
                         : "border-transparent  hover:bg-gray-50"
                     }`}
                  >
                    {tab}
                  </button>
                );
              })}
            </div>
            <div className="flex items-end justify-end gap-2">
              {!showEdit &&
                !show &&
                selectedTab !== "Invalid" &&
                hasValidData && (
                  <div className="ml-auto">
                    <SaveDataButton
                      className={
                        (show || showEdit || selectedRows.length > 0
                          ? "opacity-50 cursor-not-allowed border"
                          : "opacity-100") + ""
                      }
                      disabled={show || showEdit || selectedRows.length > 0}
                      onClick={SaveMassUploadData}
                      buttonValue={uploading ? "Saving..." : "Save Data"}
                    ></SaveDataButton>
                  </div>
                )}
            </div>
          </div>
          <div className="flex flex-row  justify-between items-center pb-1">
            {DisplayNote && data.length > 0 && (
              <div className="text-secondary italic text-xs3 mt-4">
                <p className="font-bold italic inline-block mr-1">Note: </p>
                Tick the box to delete some data.
              </div>
            )}
          </div>
          <div className="mt-5">
            <Table
              data={allData}
              columns={columns}
              loading={loading}
              selectableRows={DisplayNote && data.length > 0 ? true : false}
              selectedRows={selectedRows}
              onSelectedRowsChange={handleSelectedRowsChange}
              setOpenModal={openDeleteModal}
              clearSelectedRows={toggleClear}
              expandableRows={true}
              expandableRowsComponent={(row) => (
                <MassUploadFullView
                  data={row.data}
                  setShow={setShow}
                  isEdit={showEdit}
                  updateRow={(data) => updateRow(data)}
                  setShowEdit={setShowEdit}
                  setDisplayNote={setDisplayNote}
                  isForMassUploadCarrier={isForMassUploadCarrier}
                  Cancel={() => handleActions(row.data, "Hide")}
                />
              )}
              expandableRowExpanded={(row) => row.expandRow}
              onRowExpandToggled={undefined}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default MassUpload;
